// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea-module--textarea--1YPEf","input":"textarea-module--input--7vozp"};